/*****************************************************************************************
 * 설명 : 프로젝트관리 - 열람신청
 * URI : /project
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from "yup";


import { InputEx } from 'components/inputEx';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const ProjectOwnershipModal = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [title, setTitle] = useState('추가');

  const normalizeOwnershipMain = (list = []) => {
    if (!Array.isArray(list) || list.length < 1) return [];

    const sorted = [...list].sort((a, b) => {
      const rateA = parseFloat(a?.ownershipRate || 0);
      const rateB = parseFloat(b?.ownershipRate || 0);
      if (rateB !== rateA) return rateB - rateA;
      return String(a?.seq || '').localeCompare(String(b?.seq || ''));
    });

    return sorted.map((item, index) => ({
      ...item,
      isMain: index === 0 ? 1 : 0
    }));
  };

  /***************************************************************************************
   * 설명 : 업체 검색
  ***************************************************************************************/
  const formik = useFormik({
    initialValues: {
      seq: '',
      projectNumber: '',
      companyName: '',
      ownershipRate: '',
      memo: ''
    },
    validationSchema: Yup.object().shape({
      companyName: Yup.string().max(100, "100자리").required('필수'),
      ownershipRate: Yup.string()
        .matches(/^\d{0,3}(\.\d{0,2})?$|^$/, "숫자 3자리, 소수점 2자리")
        .required('필수'),
      memo: Yup.string().max(200, "200자리").nullable()
    }),
    onSubmit: (values) => {

      let isAdd = props.list?.filter((item) => String(item.seq) === String(values.seq));
      if( isAdd.length > 0 ) {
        let tmp = [...props.list];
        let index = 0;
        tmp.forEach((item, subIndex) => {
          if( String(item.seq) === String(formik.values.seq) ) index = subIndex;
        })

        tmp[index] = values;
        props.setList(normalizeOwnershipMain(tmp));

      // 추가
      } else {
        const tmp = [
          ...props.list,
          {...values}
        ];
        props.setList(normalizeOwnershipMain(tmp));
      }

      props.close();
    }
  });

  /***************************************************************************************
   * 설명 : 오픈 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.open ) {
      if( props.data?.seq !== undefined && props.data?.seq !== '' ) {
        setTitle('수정');

        formik.setValues(props.data);

      } else {
        setTitle('추가');

        let seq = 0;
        props.list.forEach((item) => {
          if( parseInt(item.seq) < 0 && parseInt(item.seq) < seq ) seq = parseInt(item.seq);
        });

        formik.setFieldValue('seq', seq - 1);
      }

      formik.setFieldValue("projectNumber", props.selected.projectNumber);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <section className="modal">
      <section className="modal-wrap" style={{width: '100%'}}>
        <form onSubmit={formik.handleSubmit}>
          <header className="modal-header" style={{ cursor: 'move' }} id="draggable-dialog-title">
            <div className="modal-title">참여업체 {title}</div>
            <Button className="close-btn" onClick={props.close}>×</Button>
          </header>

          <section className="modal-body">
            <div className="mb10">
              <table className="input-table">
                <colgroup>
                  <col style={{width: '30%'}} />
                  <col style={{width: '70%'}} />
                </colgroup>

                <tbody>
                  <tr>
                    <th scope="row"><label htmlFor="siteName">참여업체명</label></th>
                    <td>
                      <InputEx
                        name="companyName"
                        formik={formik}
                        fullWidth={true}
                        inputProps={{autoFocus: true}}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row"><label htmlFor="ownershipRate">지분율(%)</label></th>
                    <td>
                      {/*
                      <InputEx
                        name="ownershipRate"
                        formik={formik}
                        fullWidth={true}
                        inputProps={{
                          maxLength: 3,
                          max: 100,
                          min: 0,
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        onChange={(event) => {
                          if (event.nativeEvent.data && isNotNumber(event.nativeEvent.data) ){
                            event.target.value = onlyNumber(event.target.value);
                          }
                        }}
                        onBlur={(event) => {
                          let tmp = onlyNumber(event.target.value);
                          if( tmp > 100 ) event.target.value = 100;
                          else if( tmp < 0 ) event.target.value = 0;
                          else event.target.value = tmp;
                          formik.setFieldValue('ownershipRate', event.target.value);
                        }}
                      />
                      */}
                      <InputEx
                        name="ownershipRate"
                        formik={formik}
                        fullWidth={true}
                        inputProps={{
                          min: 0,
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                          type: 'text',
                          inputMode: 'decimal',
                          placeholder: '0.00',
                        }}
                        onKeyDown={(event) => {
                          const key = event.key;
                          const input = event.target;
                          const value = input.value;
                          const hasDot = value.includes('.');
                          const selStart = input.selectionStart ?? value.length;
                          const selEnd = input.selectionEnd ?? value.length;
                          const beforeSel = value.slice(0, selStart);
                          const afterSel = value.slice(selEnd);
                          if (['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;
                          if (event.ctrlKey || event.metaKey) {
                            if (['a', 'c', 'v', 'x'].includes(key.toLowerCase())) return;
                          }
                          if (key === '.') {
                            if (hasDot) event.preventDefault();
                            return;
                          }
                          if (!/^\d$/.test(key)) {
                            event.preventDefault();
                            return;
                          }
                          const wouldBe = beforeSel + key + afterSel;
                          const parts = wouldBe.split('.');
                          const intPart = (parts[0] || '').replace(/\D/g, '');
                          const decPart = (parts[1] || '').replace(/\D/g, '').slice(0, 2);
                          if (intPart.length > 3 || decPart.length > 2) event.preventDefault();
                        }}
                        onChange={(event) => {
                          let value = event.target.value.replace(/[^\d.]/g, '');
                          const dotIndex = value.indexOf('.');
                          if (dotIndex !== -1) {
                            value = value.slice(0, dotIndex + 1) + value.slice(dotIndex + 1).replace(/\./g, '');
                          }
                          let parts = value.split('.');
                          parts[0] = (parts[0] || '').slice(0, 3);
                          if (parts[1] !== undefined) parts[1] = parts[1].slice(0, 2);
                          value = parts.join('.');
                          event.target.value = value;
                          formik.setFieldValue('ownershipRate', value);
                        }}
                        onBlur={(event) => {
                          let tmp = parseFloat(event.target.value || 0);
                          if (tmp < 0 || isNaN(tmp)) {
                            event.target.value = '0.00';
                          } else {
                            event.target.value = tmp.toFixed(2);
                          }
                          formik.setFieldValue('ownershipRate', event.target.value);
                        }}
                      />



                    </td>
                  </tr>
                  <tr>
                    <th scope="row"><label htmlFor="memo">메모</label></th>
                    <td>
                      <InputEx
                        name="memo"
                        formik={formik}
                        fullWidth={true}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <footer className="modal-footer">
            <div className="">
              <Button
                color="secondary"
                variant="outlined"
                className="Btn"
                onClick={() => {
                  let rate = 0;
                  if( props.list.length > 0 ) {
                    props.list.forEach((item) => rate += parseFloat(item.ownershipRate));
                    rate = 100 - rate;
                  } else {
                    rate = 100;
                  }

                  if( rate < 0 ) rate = 0;

                  formik.setFieldValue('companyName', '(주)디에이그룹엔지니어링종합건축사사무소');
                  formik.setFieldValue('ownershipRate', rate);
                }}
              >디에이건축</Button>
            </div>
            <div className="text-right">
              <Button
                color="inherit"
                variant="outlined"
                className="Btn"
                onClick={() => {
                  props.close();
                }}
              >창닫기</Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                className="Btn ml10"
              >저장</Button>
            </div>
          </footer>
        </form>
      </section>
    </section>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default ProjectOwnershipModal;